import React from "react";
import { Button, Tooltip, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LockIcon from "@material-ui/icons/Lock";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { ACTIVITY_STATUS_OPTIONS } from "@icarius-pages/myTraining/constants";
import Counter from "../../../counter";
import PendingQAndAIndicator from "./pendingQAndAIndicator";

const ActivityItem = (props) => {
    const { isInstructor, isSelected, data, handleOpen } = props;

    const color = useSelector(getAppColor);

    return (
        <Button
            onClick={() => handleOpen(data.id)}
            variant="contained"
            className="whiteText"
            style={{
                borderRadius: 10,
                background: isSelected ? color : "var(--tertiaryBackgroundColor)",
                border: isSelected ? `1px solid ${color}` : "1px solid var(--borderColor)",
                textTransform: "none",
            }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography align="left" style={{ fontSize: 14 }}>
                        {data.name}
                    </Typography>
                    <Typography align="left" variant="caption" style={{ fontWeight: 600 }}>
                        - {data.typeString}
                    </Typography>
                    {data.status === ACTIVITY_STATUS_OPTIONS.blocked && (
                        <Typography align="left" variant="caption" style={{ fontWeight: 600 }}>
                            - {getLocalizedString("blockedByPendingActivity", { activityName: data.blockedBy || "" })}
                        </Typography>
                    )}
                    {data.status === ACTIVITY_STATUS_OPTIONS.pendingCorrection && (
                        <Typography align="left" variant="caption" style={{ fontWeight: 600 }}>
                            - {getLocalizedString("activityPendingInstructor")}
                        </Typography>
                    )}
                    <PendingQAndAIndicator value={data.hasPendingQuestionsOrAnswers} isInstructor={isInstructor} />
                    {data.hasNotes && (
                        <Typography align="left" variant="caption" style={{ fontWeight: 600 }}>
                            - {getLocalizedString("hasSavedNotes")}
                        </Typography>
                    )}
                </div>
                <div
                    style={{
                        height: 24,
                        width: 24,
                    }}
                >
                    {data.status === ACTIVITY_STATUS_OPTIONS.completed && (
                        <Tooltip title={getLocalizedString("complete")}>
                            <CheckCircleIcon style={{ color: "var(--ownGreen)" }} />
                        </Tooltip>
                    )}
                    {data.status === ACTIVITY_STATUS_OPTIONS.blocked && (
                        <Tooltip
                            title={getLocalizedString("blockedByPendingActivity", {
                                activityName: data.blockedBy || "",
                            })}
                        >
                            <LockIcon style={{ color: "var(--ownRed)" }} />
                        </Tooltip>
                    )}
                    {data.status === ACTIVITY_STATUS_OPTIONS.pendingCorrection && (
                        <Tooltip title={getLocalizedString("pendingCorrection")}>
                            <WatchLaterIcon />
                        </Tooltip>
                    )}
                    {isInstructor && (
                        <Counter value={data.pendingActions} label={getLocalizedString("pendingGrades")} />
                    )}
                </div>
            </div>
        </Button>
    );
};

export default ActivityItem;
